import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'
import { isDefined } from '@mntn-dev/utilities'

export function billingProfileHasCreditCard(
  billingProfile: BillingProfileDomainQueryModel
) {
  return (
    isDefined(billingProfile.billingServiceId) &&
    isDefined(billingProfile.billingServiceMethodId)
  )
}
